import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import ARWorkspace from "./components/ar3d/ar/ARWorkspace";
import ThreeDWorkspace from "./components/ar3d/threeD/ThreeDWorkspace";
import SqftWorkspace from "./components/canvas/core/SqftCanvasContainer";
import {SQFT_VIEW_MODE} from "./constants";
import useImportSQFTData from "./hocs/onLoad/useImportSQFTData";
import useUpdateSlabFeatures from "./hocs/onLoad/useUpdateSlabFeatures";

const SquareFootageToolViewWorkspace = (props) => {
  const { SQFTViewMode, visualizersLoaded } = props;
  useImportSQFTData(visualizersLoaded);
  useUpdateSlabFeatures(visualizersLoaded);

  const getWorkspace = () => {
    switch (SQFTViewMode) {
      case SQFT_VIEW_MODE.threeDMode:
        return <ThreeDWorkspace/>
      case SQFT_VIEW_MODE.threeDModeDoors:
        return <ThreeDWorkspace displayDoorsOnly={true}/>
      case SQFT_VIEW_MODE.augmentedReality:
        return <ARWorkspace/>
      case SQFT_VIEW_MODE.augmentedRealityDoors:
        return <ARWorkspace displayDoorsOnly={true}/>
      case SQFT_VIEW_MODE.twoDMode:
      default:
        return <SqftWorkspace/>
    }
  }

  return getWorkspace()
};

const mapStateToProps = (store) => {

  return {
    SQFTViewMode: store.sqftState.SQFTViewMode,
    visualizersLoaded: store.serverState.visualizersLoaded,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolViewWorkspace)
);
